document.addEventListener('DOMContentLoaded', function() {

	document.addEventListener('click', function (event) {

		//if the clicked element is a open/close accordion button
		if (event.target.matches('.custom-product-accordion')) {

			//toggle our active class
			event.target.classList.toggle('custom-product-accordion-active');
		}
	});
});